/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BankAccountVerificationStatus = {
    Verified: 'Verified',
    PendingVerification: 'PendingVerification'
} as const;
export type BankAccountVerificationStatus = typeof BankAccountVerificationStatus[keyof typeof BankAccountVerificationStatus];


export function instanceOfBankAccountVerificationStatus(value: any): boolean {
    for (const key in BankAccountVerificationStatus) {
        if (Object.prototype.hasOwnProperty.call(BankAccountVerificationStatus, key)) {
            if (BankAccountVerificationStatus[key as keyof typeof BankAccountVerificationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BankAccountVerificationStatusFromJSON(json: any): BankAccountVerificationStatus {
    return BankAccountVerificationStatusFromJSONTyped(json, false);
}

export function BankAccountVerificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountVerificationStatus {
    return json as BankAccountVerificationStatus;
}

export function BankAccountVerificationStatusToJSON(value?: BankAccountVerificationStatus | null): any {
    return value as any;
}

export function BankAccountVerificationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): BankAccountVerificationStatus {
    return value as BankAccountVerificationStatus;
}

